var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYakShaving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167.2 249.4",
    enableBackground: "new 0 0 167.2 249.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5.7,
    y: -5.7,
    fill: "#EED27E",
    width: 178.6,
    height: 260.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1E1817",
    d: "M53.2,187c0,0-7.4,1.8-16.1,10.8l2.8-1.1c0,0-7.7,4.1-10.9,11.1l3.4-2.8l-5.6,6.8l2.6-1.3l-4.7,3.6h1.7 l-2.3,2.6l3.2-1.5c0,0-3.8,5.6-5.6,12l3.4-6L20.6,233l3-5.6c0,0-3.8,9.8-4.9,14.9l2.3-4.3l-3,11.1l1.7-2.6l-1.3,9.2h129.4l-2.3-9.8 l2.1,4.3l-2.6-8.3l1.7,2.6l-3.2-7.3l1.9,0.9l-2.3-5.3l3.2,3.8c0,0-1.9-9.6-4.5-13l2.3,1.9c0,0-3.6-8.5-6.8-10.9l2.6,1.1l-4.5-4.3 l2.8,1.5l-4.7-4.3l2.6,0.9c0,0-2.8-6-7-8.3h2.3c0,0-6.6-7.2-11.6-10.2C105.3,182.3,53.2,187,53.2,187z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#615855",
    d: "M13.3,119.5c0,0,10.3,33.5,51.4,33.5v16C64.7,169.1,13.3,160.5,13.3,119.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#615855",
    d: "M152.3,119.5c0,0-10.3,33.5-51.4,33.5v16C100.9,169.1,152.3,160.5,152.3,119.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54382B",
    d: "M64.4,186.2c-18.6,0-30.6-16.9-30.6-16.9s25.8-6.1,30.6,0C64.4,176,64.4,173.7,64.4,186.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54382B",
    d: "M100.9,186.2c18.6,0,30.6-16.9,30.6-16.9s-25.8-6.1-30.6,0C100.9,176,100.9,173.7,100.9,186.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54382B",
    d: "M113.9,178c0-17.5-14.2-31.7-31.7-31.7c-17.5,0-31.7,14.2-31.7,31.7c0,13.1,15.8,35.5,15.8,39.3 c0,8.8,7.1,15.9,15.9,15.9c8.8,0,15.9-7.1,15.9-15.9C98.1,213.5,113.9,191.2,113.9,178z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#938B88",
    d: "M82.2,233.2c8.8,0,15.9-7.1,15.9-15.9c0-1.5,2.5-5.9,5.4-11.5c-5.6-5.1-13.1-21.1-21.4-21.1 s-15.7,15.9-21.4,21.1c3,5.6,5.4,10,5.4,11.5C66.3,226.1,73.4,233.2,82.2,233.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -134.5854 120.571)",
    cx: 78.2,
    cy: 222.7,
    rx: 1.5,
    ry: 6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 182.7407 4.3138)",
    cx: 86.2,
    cy: 222.7,
    rx: 1.5,
    ry: 6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.1,226.9c0,0,0.7,0.3,0.7,1.4c0,1.1,0.1,4.9,0.1,4.9h0.2c0,0,0.2-4.4,0.3-4.9c0.1-0.6,0.5-1.2,0.8-1.3 c0.3-0.1-1.1-1-1.1-1L81.1,226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E2423",
    d: "M117.3,169.2l1,0.5l-1.8-3.6l1.5,1c0,0-1.2-6.9-3.3-10.5l0.9,0.5l-2.7-4.1l1.6,1.2c0,0-3-6.5-5.8-9.7 c0.6,0.2,1.3,0.5,1.9,1c0,0-0.6-2.3-4.1-3.7l1.4-0.3l-6.5-1.6l3.2-0.2c0,0-3.5-1.6-6.1-1.8l1-0.7c0,0-2.7-0.9-5-0.5 c-0.7,0.1-1.3,0.2-1.8,0.3c-1.5-0.3-3.1-0.6-4.8-0.8l3.9-0.6c-2.4-0.2-5,0.1-6.5,0.4c-0.1,0-0.3,0-0.4,0l2.5-0.8 c-2.2-0.1-4.2,0.4-5.4,0.8c-0.1,0-0.1,0-0.2,0l2.2-0.9c-1.6,0.1-3.7,0.7-5,1c-0.3,0-0.5,0-0.8,0l1.8-1.2c-1.3,0.2-3.1,1-3.9,1.3 c0,0-0.1,0-0.1,0l1.6-1.1c-0.3,0.1-0.7,0.1-1,0.2c-1.1,0.3-2,0.8-2.6,1.1c-0.4,0-0.8,0.1-1.2,0.2l-4-0.7l1.6,1.1l-3-0.5l0.6,1 l-1.7-1l0.3,1.5l-2.6-1.2l1.4,1.5l-4,0.6h2.5c-1,0.4-1.9,0.8-2.8,1.3c-1.9,0.6-8.4,3.1-11.5,11.8l1.4-1c-0.2,0.4-0.4,0.8-0.6,1.2 l-2.1,1l0.6,0.6l-1.4,1.4l0.9-0.1l-2.3,6.3l2-2.7c0,0.1-0.1,0.2-0.1,0.3l-2.4,6.1l1.4-1.5c0,0.1,0,0.3-0.1,0.4l-1.4,2.2l1.2-0.9 c0,0-1.6,3.4-1.9,4.8c-0.3,1.4,1.1-1.2,1.1-1.2l-0.6,4.8l0.8-1.8c-0.3,3.8-0.5,8-0.5,12.6l1.1-4.4v22l0.8-7.4l0.3,15.7l0.8-4.3 l0.3,7.5l1-13.9l1,10.4l0.5-3.8L52,216l1-7.7l0.3,8.6l1.3-6.7l1.3,8.6l-0.2-10.7l0.5,2.6l0.2-9l1.1,5.6v-5l0.6,10.7l1.9-6.6v12.3 l1.4-9.3l1.9,8.3l-0.2-5.6l1.6,8.8l1.6-7.2l1.8,6.9l0.5-10.4l1.3,10.9l0.6-10.6l0.2,5.1l2.6-8.8l-1.3,8.6l2.6-5.9l-0.5,5.9 l3.4-12.3l-0.3,7.4l2.4-9.6l1.3,8.5l0.2-7.7l2.4,9.3l0.2-7.4l1.4,10.1l0.8-6.1l2.2,7.2l0.3-9.8l3,14.6l-0.8-10.4l2.7,12.2 l-1.1-15.7l2.4,10.7l-0.3-9.4l2.6,13l-0.1-7.5l0.6,5.9l2.5-7.2l1.6,8.5l0.5-11.4l2.7,13.8l-0.3-17.5l1,12.7l0.8-12.7l1.8,13.9 l0.2-12.7l1.8,14.1l0.6-16.8l1.3,14.6l1.6-12.5c0,0,2.2-8.4,2.5-18.9l0.5,1.5c0,0,0.7-10.1,0.7-13l0.5,1.3l-0.6-4.7l0.7,2.1 L117.3,169.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 64.4,
    cy: 178.6,
    r: 7.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M62.1,179.9c1.2-0.6,1.7-2.1,1-3.3c-0.4-0.8-1.3-1.3-2.2-1.3c0.4-0.4,0.8-0.7,1.3-1 c2.4-1.3,5.4-0.3,6.7,2.1c1.3,2.4,0.3,5.4-2.1,6.7c-2.4,1.3-5.4,0.3-6.7-2.1c-0.2-0.4-0.3-0.7-0.4-1.1 C60.4,180.2,61.3,180.3,62.1,179.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 98.1,
    cy: 178.6,
    r: 7.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M95.7,179.9c1.2-0.6,1.7-2.1,1-3.3c-0.4-0.8-1.3-1.3-2.2-1.3c0.4-0.4,0.8-0.7,1.3-1 c2.4-1.3,5.4-0.3,6.7,2.1c1.3,2.4,0.3,5.4-2.1,6.7c-2.4,1.3-5.4,0.3-6.7-2.1c-0.2-0.4-0.3-0.7-0.4-1.1 C94,180.2,94.9,180.3,95.7,179.9z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AEABAD",
    d: "M93.6,57.2l-33.9,7.5l-0.6,0.1l-33.9,7.5c-1.2,0.3-1.9,1.4-1.6,2.6l1,4.7c0.3,1.2,1.4,1.9,2.6,1.6 l34.5-7.6c1.2-0.3,1.9-1.4,1.6-2.6l-1-4.7c0,0,0,0,0,0l31.8-7c1.2-0.3,1-1.9,1-1.9C95,57.1,94.8,56.9,93.6,57.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F2629",
    d: "M139.6,94.6c0.6-1.1,0.5-2.4,0-3.5c0,0,0,0,0,0s-1.6-6.9-29.2-19.6C87.6,61.2,79.5,59.9,77.4,59.8 c-0.2,0-0.3,0-0.5,0c-0.1,0-0.2,0-0.2,0l0,0c-0.5,0.1-1,0.5-1.3,1c-1,2,1.9,3.5,3.3,4.3s18.5,8.9,24.8,12.1 c10.1,5.3,25.9,16.1,27,16.9c1.1,0.7,3.3,2.5,4.8,2.6C136.9,96.8,138.8,96.1,139.6,94.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D1618",
    cx: 77.1,
    cy: 61.7,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D1618",
    cx: 136.4,
    cy: 93.2,
    r: 1.6
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D49F8C",
    d: "M107.3,89.7c-3-2.1-0.5-4.6-0.5-4.6c0.5-0.8-0.5-1.5-1.6,0.1c-0.8,1.2-3.5,5.5-6.8,3.2 c-3.3-2.4-0.3-5.9-0.3-5.9c0.8-1.2,0.1-2.1-1.3-0.6c-0.8,0.8-3.2,6-7,3.3c-3.6-2.6,0.8-7.4,0.8-7.4c0.8-1.2-0.1-2-1-0.8 c-0.5,0.7-2.6,4.6-5.6,2.5c-2-1.4-1.3-3.2,0.5-5.7s11.7-14,6.3-12.7l-8.9,1.2c-1.8,0.2-3.4-1-3.7-2.8c-0.2-1.8,1-3.4,2.8-3.7 l12.2-1.7c0,0,0,0,0,0c0,0,0,0,0,0c2.1-0.2,4.2,0,6.6-1.4c16.7-23.6,51.4-13.7,22.8,21.5l-9.8,12.7 C110.6,89.8,108.7,90.8,107.3,89.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FCD3C5",
    d: "M80.9,56l1.6-0.2l1.6-0.2c0.2,1.4-0.8,2.7-2.3,2.9C80.6,58.6,79.5,58,79,57C79.5,56.5,80.1,56.1,80.9,56z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C55A4E",
    points: "167.3,-13.3 176.6,-6.4 174.9,5.8 128.9,69.9 100.7,49.7 146.5,-14.2 157.7,-21  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BF8F7E",
    d: "M107.2,86.7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#FFFCFC",
    d: "M47,70.6L26.9,75c-0.3,0.1-0.5-0.1-0.6-0.4l0,0c-0.1-0.3,0.1-0.5,0.4-0.6l20.1-4.4 c0.3-0.1,0.5,0.1,0.6,0.4l0,0C47.4,70.3,47.2,70.6,47,70.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYakShaving);
export default __webpack_public_path__ + "static/media/yak_shaving.a934ea5889bfaee86cf80ec788db847c.svg";
export { ForwardRef as ReactComponent };